import { Spinner } from '@vp/swan'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'

export const GalleryQuickViewSpinner = () => {
  const localize = useTranslations()

  return (
    <div className="img-loading qv-mcp-img-loading">
      <Spinner accessibleText={localize('Loading')} size="standard" />
    </div>
  )
}
